export const CONFIG = {
  main_api: process.env.VUE_APP_BASE_URL,
  image_api: process.env.VUE_APP_GEE_CONNECTOR,
  river_names_api: process.env.VUE_APP_RIVERS_NAME_API,
  wms_layer_url: process.env.VUE_APP_WMS_LAYER_URL
};
export default CONFIG;